export default __webpack_public_path__ + "static/media/dashAddMarkdown.c818bf3e.png";